<template>
  <div
    v-if="item.classroomName"
    v-vHover
    class="course-conflict-container"
    :class="{ courseBlockBg: newShow, conflictBg: item.conflictStatu }"
    @click="handleClick"
  >
    <!-- <div
      v-if="type !== 2"
      class="dot"
      :class="{ conflict: item.conflictStatus }"
    ></div> -->
    <div class="name">{{ item.classroomName }}</div>
    <p>{{ item.time }} {{ item.teacherName }}</p>
    <div v-vHoverOut class="action">
      <div class="flex">
        <p @click="handleUpdate">修改</p>
        <p @click="handleDelete">删除</p>
      </div>
    </div>
    <ConflictModal
      v-model="conflictModal"
      :list="conflictModalData"
    ></ConflictModal>
    <Modal
      v-model="modal"
      title="修改课程信息"
      ok-text="保存"
      width="670"
      @on-ok="handleOk"
    >
      <div class="flex-box">
        <div style="margin-right: 20px">课程名称:</div>
        {{ item.classroomName }}
      </div>
      <div class="flex-box">
        <div class="name">任教老师:</div>
        <Select
          v-model="setData.teacherIds"
          multiple
          filterable
          :remote-method="remoteMethod"
          :loading="loading"
          style="width: 400px; margin: 0 20px"
        >
          <Option
            v-for="option in teacherList"
            :key="option.teacherIds"
            :value="option.teacherIds"
          >{{ option.userName }}</Option>
        </Select>
      </div>
      <!-- <div class="flex-box">
        <div class="name">驻校教务:</div>
        <Select
          v-model="setData.teacherSchIds"
          multiple
          filterable
          :remote-method="remoteMethod"
          :loading="loading"
          style="width: 400px; margin: 0 20px"
        >
          <Option
            v-for="option in teacherList"
            :key="option.teacherIds"
            :value="option.teacherIds"
          >{{ option.userName }}</Option>
        </Select>
      </div> -->
      <div class="flex-box">
        上课时间:
        <Select v-model="setData.week" style="width: 80px; margin: 0 20px">
          <Option
            v-for="item in weekList"
            :key="item.value"
            :value="item.value"
          >{{ item.label }}</Option>
        </Select>
        {{ item.time }}
      </div>
    </Modal>
  </div>
</template>
<script>
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
import ConflictModal from './ConflictModal.vue';
import common from '@/request/common/index.js';
import { gradeList } from '@utils/dictionary';
import { mapState } from 'vuex';
export default {
  components: { ConflictModal },
  props: {
    item: {
      type: Object,
      default: () => {

      }
    },
    schoolId: {
      type: String,
      default: ''
    },
    type: {
      type: Number,
      default: 1
    },
    // 新样式
    newShow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(['portOrg'])
  },
  data() {
    return {
      modal: false,
      loading: false,
      conflictModal: false,
      conflictModalData: [],
      weekList: [{
        value: 1,
        label: '周一'
      }, {
        value: 2,
        label: '周二'
      }, {
        value: 3,
        label: '周三'
      }, {
        value: 4,
        label: '周四'
      }, {
        value: 5,
        label: '周五'
      }, {
        value: 6,
        label: '周六'
      }, {
        value: 7,
        label: '周日'
      }],
      teacherList: [],
      setData: {
        timeId: 0, // 时间段id
        teacherIds: [], // 教师列表,
        // teacherSchIds: [], // 驻校教务
        week: 0 // 周
      },
      queryTeacher: {
        pageNum: 1,
        pageSize: 20,
        userName: ''
      }
    };
  },
  methods: {
    handleClick() {
      this.$emit('updateStatus', this.item);
    },
    getGradeName(grade) {
      let result = '';
      gradeList.filter(item => {
        if (item.value === grade) {
          result = item.label;
        }
      });
      return result;
    },
    handleUpdate() {
      this.modal = true;
    },
    handleDelete() {
      this.$Modal.confirm({
        title: '提示',
        content: '是否确认删除？',
        onOk: () => {
          this.handleUpdateStatus();
        },
        onCancel: () => {

        }
      });
    },
    async handleUpdateStatus() {
      const res = await courseSchedulCenter.postCourseScheduleUpdateStatusApi({
        week: this.item.weekDate,
        timeId: this.item.timeId,
        teacherIds: this.item.teacherIdList,
        classroomId: this.item.classroomId,
        status: 2 // 1 开展 2 未开展
      });
      if (res.status === 200 && res.message && res.message.length) {
        this.conflictModalData = res.message;
        this.conflictModal = true;
      } else if (res.status === 200) {
        this.$emit('refresh');
      }
    },
    async handleOk() {
      if (this.setData.teacherIds === 0) {
        this.$Message.warning('请选择任教老师');
        return;
      }
      if (!this.setData.week) {
        this.$Message.warning('请选择上课时间');
        return;
      }
      this.setData.timeId = this.item.timeId;
      const res = await courseSchedulCenter.postCourseScheduleUpdateApi(this.setData);
      if (res.status === 200 && res.message.length) {
        this.conflictModalData = res.message;
        this.conflictModal = true;
      } else if (res.status === 200) {
        this.$emit('refresh');
      }
    },
    async getTeacherList() {
      this.queryTeacher.schoolId = this.schoolId;
      const res = await common.getTeacherListNew(this.queryTeacher);
      this.loading = false;
      console.log(res);
      this.teacherList = res.message.list.map(item => ({
        teacherIds: item.userId,
        userName: item.userName

      }));
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true;
        this.queryTeacher.userName = query;
        this.getTeacherList();
      } else {
        this.teacherList = [];
      }
    }

  },
  directives: {
    vHover: {
      // 指令的定义
      inserted: function(el) {
        el.addEventListener('mouseover', function() {
          el.querySelector('.action').style.display = 'block';
        });
        el.addEventListener('mouseout', function() {
          el.querySelector('.action').style.display = 'none';
        });
      }
    },
    vHoverOut: {
      // 指令的定义
      // inserted: function (el) {
      //   // el.addEventListener('mouseenter', function () {
      //   //   el.querySelector('.action').style.display = 'block'

      //   // })
      //   el.addEventListener('mouseout', function () {
      //     el.style.display = 'none'
      //   })

      // }
    }
  }
};
</script>
<style lang="scss" scoped>
.courseBlockBg {
  font-size: 12px;
  width: 180px;
  box-sizing: border-box;
  background-color: #4eb68c;

  padding: 8px 12px;
  border-radius: 4px 4px;
  margin-bottom: 6px;
  color: #fff;
  text-align: left;

  &:hover {
    background: #61abeb;
    cursor: pointer;
  }
}
.conflictBg {
  background-color: #ec808d;
}
/deep/.ivu-modal-body {
  padding: 40px;
}
.flex-box {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.course-conflict-container {
  position: relative;

  .dot {
    position: relative;
    top: 3px;
    flex-shrink: 0;
    width: 8px;
    height: 8px;
    margin-right: 2px;
    line-height: 20px;
    background-color: #02a7f0;
    border-radius: 100%;
    &.conflict {
      background-color: #ec808d;
    }
  }
  .name {
    text-align: left;
    margin-bottom: 4px;
  }
  .action {
    display: none;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(000, 000, 000, 0.6);
    color: #fff;
    > div {
      display: flex;
      justify-content: space-around;
      height: 100%;
      align-items: flex-end;
      padding-bottom: 8px;
      font-weight: bold;
    }
  }
}
</style>
